import routesRegistry from './registry/routes.json';
import citiesRegistry from './entities/cities.json';
import { FLIGHT_SEO_PATH_PREFIX } from './constants';

/**
 * Curated footer subset — high-traffic enabled slugs from registry/routes.json.
 * Only routes that remain enabled + enhanced are rendered.
 */
export const FOOTER_POPULAR_ROUTE_SLUGS = [
  'delhi-to-mumbai',
  'mumbai-to-delhi',
  'delhi-to-bangalore',
  'mumbai-to-goa',
  'bangalore-to-mumbai',
];

/**
 * Enabled enhanced Flight SEO routes as sitemap / suggested-route links.
 * Same filter as scripts/seo/providers/flight-seo-provider.mjs.
 *
 * @returns {Array<{ href: string, label: string }>}
 */
export function listIndexedFlightSeoRouteLinks() {
  const cityById = new Map(citiesRegistry.cities.map((city) => [city.id, city]));

  return routesRegistry.routes
    .filter((route) => route.enabled === true && route.contentProfile === 'enhanced')
    .map((route) => {
      const origin = cityById.get(route.originCityId)?.displayName;
      const destination = cityById.get(route.destinationCityId)?.displayName;
      return {
        href: `${FLIGHT_SEO_PATH_PREFIX}/${route.slug}`,
        label:
          origin && destination ? `${origin} to ${destination}` : route.slug.replace(/-/g, ' '),
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}

/**
 * 4–5 popular SEO routes for the site footer.
 * Labels use "Origin → Destination" for footer display.
 *
 * @returns {Array<{ href: string, label: string, slug: string }>}
 */
export function listPopularFooterFlightRouteLinks() {
  const cityById = new Map(citiesRegistry.cities.map((city) => [city.id, city]));
  const routeBySlug = new Map(routesRegistry.routes.map((route) => [route.slug, route]));

  return FOOTER_POPULAR_ROUTE_SLUGS.map((slug) => {
    const route = routeBySlug.get(slug);
    if (!route || route.enabled !== true || route.contentProfile !== 'enhanced') {
      return null;
    }
    const origin = cityById.get(route.originCityId)?.displayName;
    const destination = cityById.get(route.destinationCityId)?.displayName;
    return {
      slug,
      href: `${FLIGHT_SEO_PATH_PREFIX}/${route.slug}`,
      label:
        origin && destination ? `${origin} → ${destination}` : route.slug.replace(/-/g, ' '),
    };
  }).filter(Boolean);
}
